<template>
  <div
    class="flex min-h-dvh items-center justify-center bg-gradient-to-b from-surface-50 via-surface-100 to-surface-200 px-4 py-8"
  >
    <Card class="w-full max-w-xl rounded-3xl border border-surface-200/80 shadow-xl shadow-surface-900/10">
      <template #content>
        <div class="flex flex-col items-center gap-5 text-center">
<LazyDynamicLogo />
          <Divider class="my-0 w-full" />

          <Tag severity="danger" rounded class="px-3 py-1" :value="`Errore ${props.error?.statusCode || '000'}`" />

          <h1 class="text-2xl font-bold tracking-tight text-surface-900 sm:text-3xl">
            {{ t(title) }}
          </h1>

          <div v-html="t(subTitle)" class="max-w-md text-base leading-7 text-surface-700"></div>

          <p class="rounded-xl bg-surface-100 px-4 py-3 text-sm text-surface-700">
            {{ t("error_suggerimento") }}
          </p>

          <Button
            :label="t('error_effettua_login')"
            icon="pi pi-home"
            size="large"
            severity="contrast"
            class="w-full sm:w-auto"
            @click="goHome"
          />
        </div>
      </template>
    </Card>
  </div>
</template>

<script setup>
import { useI18n } from "vue-i18n";
import Card from "primevue/card";
import Button from "primevue/button";
import Image from "primevue/image";
import Tag from "primevue/tag";
import Divider from "primevue/divider";

const { t } = useI18n();
const props = defineProps(["error"]);

const title = props.error?.statusCode === 404 ? "error_titolo_404" : props.error?.statusCode === 401 ? "error_titolo_401" : "error_titolo_generale";
const subTitle =
  props.error?.statusCode === 404 ? "error_sottotitolo_404" : props.error?.statusCode === 401 ? "error_sottotitolo_401" : "error_sottotitolo_generale";
const goHome = () => navigateTo("/");
</script>
